import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Button } from "@components/Button";
import { useAddBillModal } from "@hooks/useAddBillModal";
import { useServiceProviderCategoriesQuery } from "@services/overview/queries";
import { type IOverviewJointBillService } from "@services/overview/types";

interface IDonationBillProps {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
}

export const ProviderCategories: React.FC<IDonationBillProps> = ({
  jointBillServiceId,
}) => {
  const { t } = useTranslation();
  const { openAddBillModal } = useAddBillModal();
  const { data: serviceProviderGroups } =
    useServiceProviderCategoriesQuery(true);

  return (
    <div className="group contents">
      <div className="col-start-1 col-end-[span_3] border-t border-grey-light px-4 py-4 md:col-end-[span_4] md:px-6">
        <div className="flex flex-col gap-4 md:ml-1 md:flex-row md:pl-20">
          <div className="text-grey-dark md:whitespace-nowrap lg:whitespace-normal xl:whitespace-nowrap">
            {t("bill.providerCategories.description")}
          </div>
          <div className="flex flex-wrap gap-2">
            {serviceProviderGroups?.map((id) => (
              <Button
                key={id}
                className="h-9 border-grey-hover font-normal"
                variant="secondary"
                onClick={() =>
                  openAddBillModal({
                    preselectedJointBillServiceId: jointBillServiceId,
                    preselectedCategoryId: id,
                  })
                }
              >
                {t(`common.providerCategories.${id}`)}
              </Button>
            ))}
            <Button
              className="h-9 border-grey-hover font-normal"
              variant="secondary"
              onClick={() =>
                openAddBillModal({
                  preselectedJointBillServiceId: jointBillServiceId,
                  preselectedCategoryId: "all",
                })
              }
            >
              {t("bill.providerCategories.allProviders")}
            </Button>
          </div>
        </div>
      </div>
      <div
        className={twMerge(
          "col-span-3 h-px w-full group-[&:nth-child(2)]:hidden md:col-span-4 md:px-0",
        )}
      >
        <div className="h-full w-full bg-grey-light" />
      </div>
    </div>
  );
};
